import axios from "axios"
import { removeEstabelecimento, removeNull } from "./functionsGerais"

type DidiFoodResponseBody<T> = {
    errno: number
    errmsg: string
    requestId: string
    time: number
    data: T
}

enum MenuUploadStatus {
    Waiting = 0,
    Success = 1,
    Failed = 2,
    WaitRetry = 3,
    Running = 4,
    PartialSuccess = 5,
}

type DidiFoodShopStatus = {
    shop_id: number
    app_shop_id: string
    name: string
    logo_img: string
    head_img: string
    announce: string
    addr: string
    poi_name: string
    lat: number
    lng: number
    biz_status: number
    sub_biz_status: number
    auto_switch: number
    promise_produce_time: number
    shop_phone: Array<{
        calling_code: number
        phone: number
        type: string
    }>
    biz_day_time: Array<{
        biz_day: Array<number>
        biz_time: Array<{
            begin: string
            end: string
        }>
    }>
    biz_holiday_time: Array<any>
    main_categories: {
        main_category: {
            id: string
            name: string
        }
        second_category: Array<any>
        third_category: Array<any>
    }
    shop_front_photo: string
    shop_surrounding_photo: string
    building_entrance_photo: string
    brand_id: number
}

const hasDidiFoodError = (data: DidiFoodResponseBody<any>) =>
    typeof data.errno === "number" && data.errno !== 0

const URLLambda99 = "https://coniykn9ka.execute-api.us-east-1.amazonaws.com"
const api99 = axios.create({
    baseURL: URLLambda99,
})

export async function SalvarCardapio99Food(cardapio: any) {
    const response = await api99.post("/item/upload", removeEstabelecimento(removeNull(cardapio)))

    if (response.status !== 200) throw new Error(response.data)

    const body = response.data as DidiFoodResponseBody<{
        taskID: bigint
        createTime: number
        status: MenuUploadStatus
        message: string
    }>

    if (hasDidiFoodError(body)) throw new Error(body.errmsg)

    return body.data.status
}

export async function ObterStatusLoja99(idEstabelecimento: number): Promise<DidiFoodShopStatus> {
    // TODO: Pegar id do estabelecimento
    const response = await api99.get("/shop/detail?idEstabelecimento=" + idEstabelecimento)

    if (response.status !== 200) throw new Error(response.data.errmsg)

    return response.data.data
}

export async function AtualizarDetalhesLoja(
    data: any,
    idEstabelecimento: number
): Promise<DidiFoodShopStatus> {
    const response = await api99.post("/shop/update", {
        idEstabelecimento,
        ...data,
    })

    if (response.status !== 200) throw new Error(response.data.errmsg)

    return response.data.data
}

export async function AlterarItemStatus99Food(data: {
    app_item_ids: Array<string>
    status: number
    idEstabelecimento: number
}) {
    const response = await api99.post("/item/updateItemStatus", data)

    if (response.status !== 200) throw new Error(response.data.errmsg)

    return response.data.data
}

enum StatusEnum {
    Online = 1,
    Offline = 2,
}

enum AutoSwitchStatusEnum {
    AutoSetOnlyOnline = 1,
    AutoSetOnlyOffline = 2,
    AutoSetStatus = 3,
}

export async function AlterarShopStatus99Food(data: {
    biz_status: StatusEnum
    auto_switch: AutoSwitchStatusEnum
}) {
    const response = await api99.post("/shop/setStatus", data)

    if (response.status !== 200) throw new Error(response.data.errmsg)

    return response.data.data
}
